<template>
  <PageLayout>
    <b-row>
      <b-col offset-lg="3" class="col-lg-6 card-col col-md-12 col-sm-12 col-12">
        <b-form class="login-form" @submit.stop.prevent="onSubmit">
          <div class="vtd-card-block">
            <h5 class="vtd-card-title">ViewTrail Password Assistance</h5>
            <h6>
              To set your password or create a new one please submit your
              details below.
            </h6>
            <b-form-group
              label="Password"
              label-for="input-password"
              class="vtd-form-group"
            >
              <b-form-input
                id="input-password"
                v-model.trim="password"
                type="text"
                class="vtd-form-control vtd-form-control-lg bg-light"
              />
            </b-form-group>
            <b-form-group
              label="Confirm Password"
              label-for="input-password"
              class="vtd-form-group"
            >
              <b-form-input
                id="input-password"
                v-model.trim="passwordCheck"
                type="text"
                class="vtd-form-control vtd-form-control-lg bg-light"
              />
            </b-form-group>
            <b-alert :show="passwordError" variant="danger"
              >Passwords do not match</b-alert
            >
            <b-alert :show="changePasswordError" variant="danger"
              >Your submission has failed. Please check and resubmit.</b-alert
            >
          </div>
          <div class="vtd-card-footer">
            <b-button
              type="submit"
              class="
                vtd-btn
                vtd-btn-success
                vtd-btn-login
                vtd-btn-xl
                vtd-btn-block
                vtd-btn-center
                vtd-text-white
              "
            >
              Reset Password
            </b-button>
          </div>
        </b-form>
      </b-col>
    </b-row>
  </PageLayout>
</template>

<script>
import PageLayout from "@/partials/home-layout";
import { sendPassword } from "./services";
export default {
  components: {
    PageLayout,
  },
  data() {
    return {
      password: "",
      passwordCheck: "",
      passwordError: false,
      changePasswordError: false,
    };
  },

  async created() {
    let token = this.$route.params.token;
  },

  methods: {
    async onSubmit() {
      let token = this.$route.params.token;
      this.passwordError = false;

      if (this.password !== this.passwordCheck) {
        this.passwordError = true;
        return;
      }
      const result = await sendPassword({
        password: this.password,
        token: token,
      });
      if (result.error) {
        this.changePasswordError = true;
        return;
      }
      if (result.data.status === "password changed") {
        // go to login page
        this.$router.push("/login");
      }
    },
  },
};
</script>
